import React from 'react'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { DatePicker } from '@material-ui/pickers'
import { Grid } from '@material-ui/core'
import { Bar } from 'react-chartjs-2'
import Refresh from '@material-ui/icons/Refresh'
import Button from 'src/components/sharedComponents/CustomButtons/Button'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import * as Utils from 'src/utils/chartsUtils'
import TableAA from 'src/components/reports/Tables/TableAA'
import TableImportsCompanies from 'src/components/reports/Tables/TableImportsCompanies'

const useStyles = makeStyles(() => ({
  root: {
    '& > *': {
      color: '#fff',
    },
  },
  labelTitle: {
    backgroundColor: '#000000',
    color: '#fff',
    paddingLeft: '4px',
    borderRadius: '2px',
  },
}))

const ImportOriginalIndiaSpareParts = (props) => {
  const { selectedDate, handleDateChange } = props

  const history = useHistory()
  const classes = useStyles()

  return (
    <>
      <CardTitle
        title="Importacion total de repuestos originales India"
        component={
          <DatePicker
            autoOk
            variant="inline"
            views={['year']}
            className={classes.root}
            value={selectedDate}
            maxDate={new Date()}
            onChange={handleDateChange}
          />
        }
      />
      <Button link onClick={() => history.push('/reports/board')}>
        <Refresh /> Volver al Menú
      </Button>
      <Card>
        <CardBody>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} lg={6}>
              <br />
              <div className={classes.labelTitle}>
                <h4>Comparativa año anterior</h4>
              </div>
              <br />
              <TableAA
                array={props.total1}
                selectedDate={selectedDate}
                param="YYYY"
              />
            </Grid>
            <Grid item xs={12} sm={12} lg={6}>
              <br />
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <br />
              <div className={classes.labelTitle}>
                <h4>Mix en tiempo</h4>
              </div>
              <br />
              <Bar
                data={Utils.customBarLineDataGroup(
                  props.gTotal1,
                  'EMPRESA',
                  'PERIODO1',
                  'YYYY',
                  '100',
                )}
                options={Utils.optionsGroupedCharts}
              />
              <br />
              <div className={classes.labelTitle}>
                <h4>Por categoría </h4>
              </div>
              <br />
              <TableImportsCompanies
                title="CATEGORÍA"
                array={props.total2}
                param="YYYY"
                order="DIMENSION"
                selectedDate={selectedDate}
              />
              <br />
              <div className={classes.labelTitle}>
                <h4>Por subcategoria</h4>
              </div>
              <br />
              <TableImportsCompanies
                title="SUBCATEGORIA"
                array={props.total3}
                param="YYYY"
                order="SUBCATEGORIA"
                selectedDate={selectedDate}
              />
              <br />
              <div className={classes.labelTitle}>
                <h4>Por compañia</h4>
              </div>
              <br />
              <TableImportsCompanies
                title="EMPRESA"
                array={props.total4}
                param="YYYY"
                order="EMPRESA"
                selectedDate={selectedDate}
              />
            </Grid>
          </Grid>
        </CardBody>
      </Card>
    </>
  )
}

export default ImportOriginalIndiaSpareParts
